var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-grid',{staticClass:"mb-2 process-history",attrs:{"data":_vm.deleteServers,"columns":_vm.serverColumns}})}
var staticRenderFns = []

export { render, staticRenderFns }